import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';

export const GET_USERS_INFO = gql`
  query findUsersMetadata($userIds: [String]) {
    findUsersMetadata(userIds: $userIds) {
      id
      firstName
      lastName
      email
      currentAccountRoleId
    }
  }
`;

const emptyRes = { '-1': 'Zscaler' };

export const useGetUsersInfo = (
  userIds,
  select = data =>
    data?.reduce(
      (obj, { id, firstName, lastName }) => ({
        ...obj,
        [id]: `${firstName} ${lastName}`,
      }),
      emptyRes
    ),
  defaultRes: object = emptyRes,
  enabled: boolean = true
) => {
  const {
    data: usersInfo = defaultRes,
    refetch,
    isLoading,
    isPending,
  } = useGqlQuery({
    queryKey: [QueryKey.UsersInfo, ...userIds, select.toString()],
    query: GET_USERS_INFO,
    variables: { userIds },
    select,
    enabled: !!userIds.length && enabled,
    gcTime: 0,
  });
  return { usersInfo, refetch, isLoading, isPending };
};

export const useGetUsersInfoByEmail = ({
  userEmails,
  select = data =>
    data?.reduce(
      (obj, { email, firstName, lastName }) => ({
        ...obj,
        [email]: `${firstName} ${lastName}`,
      }),
      emptyRes
    ),
  defaultRes = emptyRes,
  enabled = true,
}: {
  userEmails: string[];
  select?: (data: any) => Record<string, string>;
  defaultRes?: Record<string, string>;
  enabled?: boolean;
}) => {
  const {
    data: usersInfo = defaultRes,
    refetch,
    isLoading,
    isPending,
  } = useGqlQuery({
    queryKey: [QueryKey.UsersInfoByEmail, ...userEmails, select.toString()],
    query: GET_USERS_INFO_BY_EMAIL,
    variables: { userEmails },
    select,
    enabled: !!userEmails.length && enabled,
    gcTime: 0,
  });
  return { usersInfo, refetch, isLoading, isPending };
};

export const GET_USERS_INFO_BY_EMAIL = gql`
  query findUsersMetadataByUsersEmail($userEmails: [String]) {
    findUsersMetadataByUsersEmail(userEmails: $userEmails) {
      id
      firstName
      lastName
      email
      currentAccountRoleId
    }
  }
`;
